const sampleEmployees = [
  {
    "Employer Information": {
      "Legal Employer Name": "Acme Corporation",
      "Employer company": "Acme Group"
    },
    "Personal Identification": {
      "Person Number": "EMP001",
      "Surname": "Smith",
      "First Names": "Johnathan",
      "Known As": "John",
      "Title": "Mr",
      "Person Date of Birth": "1985-06-15",
      "Gender": "Male",
      "Marital Status": "Single",
      "Nationality": "South African",
      "Primary National Identifier Number": "8506151234087",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2030-05-20"
    },
    "Contact Information": {
      "Email Address": "john.smith@example.com",
      "Address Line 1": "123 Main Street",
      "City": "Pretoria",
      "Country": "South Africa",
      "Region 1": "Gauteng",
      "Region 2": "Tshwane"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2010-03-01",
      "Current Legal Employer Hire Date": "2012-08-15",
      "Work Relationship Start Date": "2012-08-15",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1001",
      "Assignment Number": "ASGN001",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2012-08-15",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "6 months",
      "Probation End Date": "2013-02-15",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "Tech Solutions",
      "Job": "Software Engineer",
      "Job Family": "Engineering",
      "Job Code": "ENG01",
      "Reward Level": "Level 4",
      "Department": "Development",
      "Location Name": "HQ",
      "Position Code": "POS1001",
      "Position": "Backend Developer"
    },
    "Manager Information": {
      "Manager Flag": "Yes",
      "Manager Employee Number": "EMP100",
      "Manager Name": "Sarah Johnson"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Technical Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX123456789",
      "Bonus Agreement Score": "Excellent"
    },
    "Performance and Service": {
      "Years of service": "13",
      "Restraint flag": "No",
      "Notice period": "1 Month",
      "IPF score": "4.5",
      "Talent outcome score": "A"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 50000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 2500 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 2000 },
          "Provident fund": { "Local": 1800 },
          "Risk benefits": { "Local": 800 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 400 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 300 },
          "Lifestyle benefits": { "Local": 1000 },
          "Cellphone allowance": { "Local": 600 },
          "Per diem": { "Local": 1500 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 300 },
          "Airtime": { "Local": 200 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 500 },
          "Overtime pay": { "Local": 1000 },
          "Callout payment": { "Local": 200 },
          "Shift allowance": { "Local": 800 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 0 },
          "Performance share plan": { "Local": 3000 },
          "Performance bonus plan": { "Local": 4000 },
          "Sales commission scheme": { "Local": 1500 },
          "Sales bonus": { "Local": 2000 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 300 }
      }
    }
  },
  {
    "Employer Information": {
      "Legal Employer Name": "Global Solutions Inc.",
      "Employer company": "Global Holdings"
    },
    "Personal Identification": {
      "Person Number": "EMP002",
      "Surname": "Ndlovu",
      "First Names": "Thandiwe",
      "Known As": "Thandi",
      "Title": "Ms",
      "Person Date of Birth": "1990-03-22",
      "Gender": "Female",
      "Marital Status": "Married",
      "Nationality": "South African",
      "Primary National Identifier Number": "9003225678089",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2028-11-01"
    },
    "Contact Information": {
      "Email Address": "thandi.ndlovu@example.com",
      "Address Line 1": "45 Oak Avenue",
      "City": "Johannesburg",
      "Country": "South Africa",
      "Region 1": "Gauteng",
      "Region 2": "City of Johannesburg"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2015-07-10",
      "Current Legal Employer Hire Date": "2015-07-10",
      "Work Relationship Start Date": "2015-07-10",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1002",
      "Assignment Number": "ASGN002",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2015-07-10",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "3 months",
      "Probation End Date": "2015-10-10",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "Marketing & Sales",
      "Job": "Marketing Manager",
      "Job Family": "Marketing",
      "Job Code": "MKT02",
      "Reward Level": "Level 5",
      "Department": "Brand Management",
      "Location Name": "Rosebank Office",
      "Position Code": "POS1002",
      "Position": "Senior Marketing Manager"
    },
    "Manager Information": {
      "Manager Flag": "No",
      "Manager Employee Number": "EMP101",
      "Manager Name": "David Lee"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Management Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX987654321",
      "Bonus Agreement Score": "Very Good"
    },
    "Performance and Service": {
      "Years of service": "9",
      "Restraint flag": "No",
      "Notice period": "2 Months",
      "IPF score": "4.2",
      "Talent outcome score": "B+"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 65000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 3000 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 2500 },
          "Provident fund": { "Local": 2000 },
          "Risk benefits": { "Local": 900 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 450 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 350 },
          "Lifestyle benefits": { "Local": 1200 },
          "Cellphone allowance": { "Local": 700 },
          "Per diem": { "Local": 1600 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 350 },
          "Airtime": { "Local": 250 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 0 },
          "Overtime pay": { "Local": 0 },
          "Callout payment": { "Local": 0 },
          "Shift allowance": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 0 },
          "Performance share plan": { "Local": 4000 },
          "Performance bonus plan": { "Local": 5000 },
          "Sales commission scheme": { "Local": 0 },
          "Sales bonus": { "Local": 0 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 400 }
      }
    }
  },
  {
    "Employer Information": {
      "Legal Employer Name": "Innovative Tech Solutions",
      "Employer company": "Innovate Holdings"
    },
    "Personal Identification": {
      "Person Number": "EMP003",
      "Surname": "Van Wyk",
      "First Names": "Pieter",
      "Known As": "Piet",
      "Title": "Mr",
      "Person Date of Birth": "1978-11-05",
      "Gender": "Male",
      "Marital Status": "Married",
      "Nationality": "South African",
      "Primary National Identifier Number": "7811051234086",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2032-03-10"
    },
    "Contact Information": {
      "Email Address": "pieter.vanwyk@example.com",
      "Address Line 1": "7 Green Street",
      "City": "Cape Town",
      "Country": "South Africa",
      "Region 1": "Western Cape",
      "Region 2": "City of Cape Town"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2005-01-20",
      "Current Legal Employer Hire Date": "2005-01-20",
      "Work Relationship Start Date": "2005-01-20",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1003",
      "Assignment Number": "ASGN003",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2005-01-20",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "6 months",
      "Probation End Date": "2005-07-20",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "Executive Management",
      "Job": "Chief Technology Officer",
      "Job Family": "Executive",
      "Job Code": "EXEC01",
      "Reward Level": "Level 8",
      "Department": "Leadership",
      "Location Name": "Cape Town HQ",
      "Position Code": "POS1003",
      "Position": "CTO"
    },
    "Manager Information": {
      "Manager Flag": "Yes",
      "Manager Employee Number": "EMP050",
      "Manager Name": "Emily Chen"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Executive Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX112233445",
      "Bonus Agreement Score": "Outstanding"
    },
    "Performance and Service": {
      "Years of service": "20",
      "Restraint flag": "Yes",
      "Notice period": "3 Months",
      "IPF score": "4.8",
      "Talent outcome score": "A+"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 150000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 8000 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 5000 },
          "Provident fund": { "Local": 4000 },
          "Risk benefits": { "Local": 1500 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 800 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 0 },
          "Lifestyle benefits": { "Local": 3000 },
          "Cellphone allowance": { "Local": 1500 },
          "Per diem": { "Local": 3000 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 500 },
          "Airtime": { "Local": 500 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 0 },
          "Overtime pay": { "Local": 0 },
          "Callout payment": { "Local": 0 },
          "Shift allowance": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 50000 },
          "Performance share plan": { "Local": 10000 },
          "Performance bonus plan": { "Local": 15000 },
          "Sales commission scheme": { "Local": 0 },
          "Sales bonus": { "Local": 0 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 1000 }
      }
    }
  },
  {
    "Employer Information": {
      "Legal Employer Name": "Future Dynamics Ltd.",
      "Employer company": "Future Group"
    },
    "Personal Identification": {
      "Person Number": "EMP004",
      "Surname": "Jones",
      "First Names": "Samantha",
      "Known As": "Sam",
      "Title": "Ms",
      "Person Date of Birth": "1992-09-01",
      "Gender": "Female",
      "Marital Status": "Single",
      "Nationality": "South African",
      "Primary National Identifier Number": "9209019876088",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2029-07-25"
    },
    "Contact Information": {
      "Email Address": "samantha.jones@example.com",
      "Address Line 1": "22 Ocean View Drive",
      "City": "Durban",
      "Country": "South Africa",
      "Region 1": "KwaZulu-Natal",
      "Region 2": "eThekwini"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2018-02-01",
      "Current Legal Employer Hire Date": "2018-02-01",
      "Work Relationship Start Date": "2018-02-01",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1004",
      "Assignment Number": "ASGN004",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2018-02-01",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "6 months",
      "Probation End Date": "2018-08-01",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "Customer Relations",
      "Job": "Customer Service Representative",
      "Job Family": "Client Services",
      "Job Code": "CSR01",
      "Reward Level": "Level 2",
      "Department": "Support",
      "Location Name": "Durban Call Centre",
      "Position Code": "POS1004",
      "Position": "Senior CSR"
    },
    "Manager Information": {
      "Manager Flag": "No",
      "Manager Employee Number": "EMP102",
      "Manager Name": "Michael Brown"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Administrative Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX556677889",
      "Bonus Agreement Score": "Good"
    },
    "Performance and Service": {
      "Years of service": "7",
      "Restraint flag": "No",
      "Notice period": "1 Month",
      "IPF score": "3.9",
      "Talent outcome score": "B"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 28000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 0 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 1500 },
          "Provident fund": { "Local": 1000 },
          "Risk benefits": { "Local": 600 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 300 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 250 },
          "Lifestyle benefits": { "Local": 0 },
          "Cellphone allowance": { "Local": 300 },
          "Per diem": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 200 },
          "Airtime": { "Local": 150 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 0 },
          "Overtime pay": { "Local": 500 },
          "Callout payment": { "Local": 0 },
          "Shift allowance": { "Local": 300 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 0 },
          "Performance share plan": { "Local": 0 },
          "Performance bonus plan": { "Local": 1000 },
          "Sales commission scheme": { "Local": 0 },
          "Sales bonus": { "Local": 0 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 150 }
      }
    }
  },
  {
    "Employer Information": {
      "Legal Employer Name": "Prime Innovations",
      "Employer company": "Prime Group"
    },
    "Personal Identification": {
      "Person Number": "EMP005",
      "Surname": "Naidoo",
      "First Names": "Priya",
      "Known As": "Priya",
      "Title": "Ms",
      "Person Date of Birth": "1988-07-28",
      "Gender": "Female",
      "Marital Status": "Divorced",
      "Nationality": "South African",
      "Primary National Identifier Number": "8807281234085",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2031-09-10"
    },
    "Contact Information": {
      "Email Address": "priya.naidoo@example.com",
      "Address Line 1": "10 Palm Street",
      "City": "Port Elizabeth",
      "Country": "South Africa",
      "Region 1": "Eastern Cape",
      "Region 2": "Nelson Mandela Bay"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2013-05-15",
      "Current Legal Employer Hire Date": "2013-05-15",
      "Work Relationship Start Date": "2013-05-15",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1005",
      "Assignment Number": "ASGN005",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2013-05-15",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "6 months",
      "Probation End Date": "2013-11-15",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "Finance & Accounting",
      "Job": "Financial Analyst",
      "Job Family": "Finance",
      "Job Code": "FIN03",
      "Reward Level": "Level 4",
      "Department": "Financial Reporting",
      "Location Name": "PE Office",
      "Position Code": "POS1005",
      "Position": "Senior Financial Analyst"
    },
    "Manager Information": {
      "Manager Flag": "No",
      "Manager Employee Number": "EMP103",
      "Manager Name": "Robert Green"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Professional Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX998877665",
      "Bonus Agreement Score": "Excellent"
    },
    "Performance and Service": {
      "Years of service": "11",
      "Restraint flag": "No",
      "Notice period": "1 Month",
      "IPF score": "4.6",
      "Talent outcome score": "A"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 45000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 1500 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 2200 },
          "Provident fund": { "Local": 1700 },
          "Risk benefits": { "Local": 750 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 350 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 280 },
          "Lifestyle benefits": { "Local": 800 },
          "Cellphone allowance": { "Local": 550 },
          "Per diem": { "Local": 1000 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 280 },
          "Airtime": { "Local": 180 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 0 },
          "Overtime pay": { "Local": 0 },
          "Callout payment": { "Local": 0 },
          "Shift allowance": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 0 },
          "Performance share plan": { "Local": 2500 },
          "Performance bonus plan": { "Local": 3500 },
          "Sales commission scheme": { "Local": 0 },
          "Sales bonus": { "Local": 0 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 250 }
      }
    }
  },
  {
    "Employer Information": {
      "Legal Employer Name": "Apex Systems",
      "Employer company": "Apex Group"
    },
    "Personal Identification": {
      "Person Number": "EMP006",
      "Surname": "Mokoena",
      "First Names": "Sipho",
      "Known As": "Sipho",
      "Title": "Mr",
      "Person Date of Birth": "1983-04-10",
      "Gender": "Male",
      "Marital Status": "Married",
      "Nationality": "South African",
      "Primary National Identifier Number": "8304101234084",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2027-02-28"
    },
    "Contact Information": {
      "Email Address": "sipho.mokoena@example.com",
      "Address Line 1": "33 River Road",
      "City": "Bloemfontein",
      "Country": "South Africa",
      "Region 1": "Free State",
      "Region 2": "Mangaung"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2008-09-01",
      "Current Legal Employer Hire Date": "2008-09-01",
      "Work Relationship Start Date": "2008-09-01",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1006",
      "Assignment Number": "ASGN006",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2008-09-01",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "6 months",
      "Probation End Date": "2009-03-01",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "Operations",
      "Job": "Operations Manager",
      "Job Family": "Operations",
      "Job Code": "OPS01",
      "Reward Level": "Level 6",
      "Department": "Logistics",
      "Location Name": "Bloemfontein Hub",
      "Position Code": "POS1006",
      "Position": "Regional Operations Manager"
    },
    "Manager Information": {
      "Manager Flag": "Yes",
      "Manager Employee Number": "EMP104",
      "Manager Name": "Jessica White"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Management Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX121212121",
      "Bonus Agreement Score": "Excellent"
    },
    "Performance and Service": {
      "Years of service": "16",
      "Restraint flag": "No",
      "Notice period": "2 Months",
      "IPF score": "4.7",
      "Talent outcome score": "A"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 75000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 4000 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 3000 },
          "Provident fund": { "Local": 2500 },
          "Risk benefits": { "Local": 1000 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 500 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 0 },
          "Lifestyle benefits": { "Local": 1500 },
          "Cellphone allowance": { "Local": 800 },
          "Per diem": { "Local": 2000 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 400 },
          "Airtime": { "Local": 300 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 0 },
          "Overtime pay": { "Local": 0 },
          "Callout payment": { "Local": 0 },
          "Shift allowance": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 0 },
          "Performance share plan": { "Local": 5000 },
          "Performance bonus plan": { "Local": 6000 },
          "Sales commission scheme": { "Local": 0 },
          "Sales bonus": { "Local": 0 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 500 }
      }
    }
  },
  {
    "Employer Information": {
      "Legal Employer Name": "Vanguard Solutions",
      "Employer company": "Vanguard Holdings"
    },
    "Personal Identification": {
      "Person Number": "EMP007",
      "Surname": "Peters",
      "First Names": "Nomusa",
      "Known As": "Nomusa",
      "Title": "Ms",
      "Person Date of Birth": "1995-12-03",
      "Gender": "Female",
      "Marital Status": "Single",
      "Nationality": "South African",
      "Primary National Identifier Number": "9512031234083",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2030-01-15"
    },
    "Contact Information": {
      "Email Address": "nomusa.peters@example.com",
      "Address Line 1": "8 High Street",
      "City": "Pretoria",
      "Country": "South Africa",
      "Region 1": "Gauteng",
      "Region 2": "Tshwane"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2020-06-01",
      "Current Legal Employer Hire Date": "2020-06-01",
      "Work Relationship Start Date": "2020-06-01",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1007",
      "Assignment Number": "ASGN007",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2020-06-01",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "3 months",
      "Probation End Date": "2020-09-01",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "Human Resources",
      "Job": "HR Generalist",
      "Job Family": "Human Resources",
      "Job Code": "HRG01",
      "Reward Level": "Level 3",
      "Department": "Employee Relations",
      "Location Name": "Pretoria Office",
      "Position Code": "POS1007",
      "Position": "HR Business Partner"
    },
    "Manager Information": {
      "Manager Flag": "No",
      "Manager Employee Number": "EMP105",
      "Manager Name": "Linda Khumalo"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Professional Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX334455667",
      "Bonus Agreement Score": "Good"
    },
    "Performance and Service": {
      "Years of service": "5",
      "Restraint flag": "No",
      "Notice period": "1 Month",
      "IPF score": "4.0",
      "Talent outcome score": "B+"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 38000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 1000 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 1800 },
          "Provident fund": { "Local": 1400 },
          "Risk benefits": { "Local": 700 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 320 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 200 },
          "Lifestyle benefits": { "Local": 600 },
          "Cellphone allowance": { "Local": 400 },
          "Per diem": { "Local": 800 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 250 },
          "Airtime": { "Local": 150 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 0 },
          "Overtime pay": { "Local": 0 },
          "Callout payment": { "Local": 0 },
          "Shift allowance": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 0 },
          "Performance share plan": { "Local": 1500 },
          "Performance bonus plan": { "Local": 2000 },
          "Sales commission scheme": { "Local": 0 },
          "Sales bonus": { "Local": 0 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 200 }
      }
    }
  },
  {
    "Employer Information": {
      "Legal Employer Name": "Innovative Edge",
      "Employer company": "Edge Group"
    },
    "Personal Identification": {
      "Person Number": "EMP008",
      "Surname": "Mohamed",
      "First Names": "Ahmed",
      "Known As": "Ahmed",
      "Title": "Mr",
      "Person Date of Birth": "1980-01-25",
      "Gender": "Male",
      "Marital Status": "Married",
      "Nationality": "South African",
      "Primary National Identifier Number": "8001251234082",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2033-04-05"
    },
    "Contact Information": {
      "Email Address": "ahmed.mohamed@example.com",
      "Address Line 1": "55 Park Lane",
      "City": "Johannesburg",
      "Country": "South Africa",
      "Region 1": "Gauteng",
      "Region 2": "City of Johannesburg"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2007-11-01",
      "Current Legal Employer Hire Date": "2007-11-01",
      "Work Relationship Start Date": "2007-11-01",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1008",
      "Assignment Number": "ASGN008",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2007-11-01",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "6 months",
      "Probation End Date": "2008-05-01",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "Research & Development",
      "Job": "Research Scientist",
      "Job Family": "Science",
      "Job Code": "SCI01",
      "Reward Level": "Level 7",
      "Department": "Innovation Lab",
      "Location Name": "Johannesburg R&D",
      "Position Code": "POS1008",
      "Position": "Principal Research Scientist"
    },
    "Manager Information": {
      "Manager Flag": "Yes",
      "Manager Employee Number": "EMP106",
      "Manager Name": "Dr. Sarah Adams"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Research Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX667788990",
      "Bonus Agreement Score": "Outstanding"
    },
    "Performance and Service": {
      "Years of service": "17",
      "Restraint flag": "Yes",
      "Notice period": "3 Months",
      "IPF score": "4.9",
      "Talent outcome score": "A+"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 90000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 5000 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 3500 },
          "Provident fund": { "Local": 2800 },
          "Risk benefits": { "Local": 1200 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 600 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 0 },
          "Lifestyle benefits": { "Local": 2000 },
          "Cellphone allowance": { "Local": 1000 },
          "Per diem": { "Local": 2500 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 450 },
          "Airtime": { "Local": 350 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 0 },
          "Overtime pay": { "Local": 0 },
          "Callout payment": { "Local": 0 },
          "Shift allowance": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 10000 },
          "Performance share plan": { "Local": 7000 },
          "Performance bonus plan": { "Local": 8000 },
          "Sales commission scheme": { "Local": 0 },
          "Sales bonus": { "Local": 0 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 800 }
      }
    }
  },
  {
    "Employer Information": {
      "Legal Employer Name": "Dynamic Growth Co.",
      "Employer company": "Dynamic Group"
    },
    "Personal Identification": {
      "Person Number": "EMP009",
      "Surname": "Singh",
      "First Names": "Renuka",
      "Known As": "Renu",
      "Title": "Mrs",
      "Person Date of Birth": "1989-08-18",
      "Gender": "Female",
      "Marital Status": "Married",
      "Nationality": "South African",
      "Primary National Identifier Number": "8908181234081",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2034-06-20"
    },
    "Contact Information": {
      "Email Address": "renuka.singh@example.com",
      "Address Line 1": "15 Bay Road",
      "City": "Durban",
      "Country": "South Africa",
      "Region 1": "KwaZulu-Natal",
      "Region 2": "eThekwini"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2014-04-01",
      "Current Legal Employer Hire Date": "2014-04-01",
      "Work Relationship Start Date": "2014-04-01",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1009",
      "Assignment Number": "ASGN009",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2014-04-01",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "6 months",
      "Probation End Date": "2014-10-01",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "Sales & Distribution",
      "Job": "Sales Executive",
      "Job Family": "Sales",
      "Job Code": "SAL02",
      "Reward Level": "Level 4",
      "Department": "Corporate Sales",
      "Location Name": "Durban Sales Office",
      "Position Code": "POS1009",
      "Position": "Key Account Manager"
    },
    "Manager Information": {
      "Manager Flag": "No",
      "Manager Employee Number": "EMP107",
      "Manager Name": "Chris Goudge"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Sales Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX445566778",
      "Bonus Agreement Score": "Very Good"
    },
    "Performance and Service": {
      "Years of service": "11",
      "Restraint flag": "No",
      "Notice period": "1 Month",
      "IPF score": "4.3",
      "Talent outcome score": "B+"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 40000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 2000 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 2000 },
          "Provident fund": { "Local": 1600 },
          "Risk benefits": { "Local": 700 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 300 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 250 },
          "Lifestyle benefits": { "Local": 700 },
          "Cellphone allowance": { "Local": 500 },
          "Per diem": { "Local": 900 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 280 },
          "Airtime": { "Local": 180 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 0 },
          "Overtime pay": { "Local": 0 },
          "Callout payment": { "Local": 0 },
          "Shift allowance": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 0 },
          "Performance share plan": { "Local": 2000 },
          "Performance bonus plan": { "Local": 3000 },
          "Sales commission scheme": { "Local": 2500 },
          "Sales bonus": { "Local": 1800 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 300 }
      }
    }
  },
  {
    "Employer Information": {
      "Legal Employer Name": "Synergy Solutions",
      "Employer company": "Synergy Group"
    },
    "Personal Identification": {
      "Person Number": "EMP010",
      "Surname": "Du Plessis",
      "First Names": "Christiaan",
      "Known As": "Chris",
      "Title": "Mr",
      "Person Date of Birth": "1975-02-09",
      "Gender": "Male",
      "Marital Status": "Married",
      "Nationality": "South African",
      "Primary National Identifier Number": "7502091234080",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2035-10-01"
    },
    "Contact Information": {
      "Email Address": "christiaan.duplessis@example.com",
      "Address Line 1": "99 Old Mill Road",
      "City": "Pretoria",
      "Country": "South Africa",
      "Region 1": "Gauteng",
      "Region 2": "Tshwane"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2000-10-01",
      "Current Legal Employer Hire Date": "2000-10-01",
      "Work Relationship Start Date": "2000-10-01",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1010",
      "Assignment Number": "ASGN010",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2000-10-01",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "6 months",
      "Probation End Date": "2001-04-01",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "IT Infrastructure",
      "Job": "IT Manager",
      "Job Family": "IT",
      "Job Code": "ITM01",
      "Reward Level": "Level 7",
      "Department": "Infrastructure",
      "Location Name": "Centurion Data Centre",
      "Position Code": "POS1010",
      "Position": "Head of IT Infrastructure"
    },
    "Manager Information": {
      "Manager Flag": "Yes",
      "Manager Employee Number": "EMP051",
      "Manager Name": "Ntombi Mthembu"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Technical Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX001122334",
      "Bonus Agreement Score": "Excellent"
    },
    "Performance and Service": {
      "Years of service": "25",
      "Restraint flag": "No",
      "Notice period": "3 Months",
      "IPF score": "4.7",
      "Talent outcome score": "A+"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 85000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 4500 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 3200 },
          "Provident fund": { "Local": 2600 },
          "Risk benefits": { "Local": 1100 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 550 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 0 },
          "Lifestyle benefits": { "Local": 1800 },
          "Cellphone allowance": { "Local": 900 },
          "Per diem": { "Local": 2200 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 420 },
          "Airtime": { "Local": 320 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 0 },
          "Overtime pay": { "Local": 0 },
          "Callout payment": { "Local": 0 },
          "Shift allowance": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 0 },
          "Performance share plan": { "Local": 6000 },
          "Performance bonus plan": { "Local": 7000 },
          "Sales commission scheme": { "Local": 0 },
          "Sales bonus": { "Local": 0 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 700 }
      }
    }
  },
  {
    "Employer Information": {
      "Legal Employer Name": "Zenith Innovations",
      "Employer company": "Zenith Group"
    },
    "Personal Identification": {
      "Person Number": "EMP011",
      "Surname": "Khumalo",
      "First Names": "Sindi",
      "Known As": "Sindi",
      "Title": "Ms",
      "Person Date of Birth": "1993-10-05",
      "Gender": "Female",
      "Marital Status": "Single",
      "Nationality": "South African",
      "Primary National Identifier Number": "9310051234079",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2032-11-20"
    },
    "Contact Information": {
      "Email Address": "sindi.khumalo@example.com",
      "Address Line 1": "77 Sunset Boulevard",
      "City": "Cape Town",
      "Country": "South Africa",
      "Region 1": "Western Cape",
      "Region 2": "City of Cape Town"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2019-01-01",
      "Current Legal Employer Hire Date": "2019-01-01",
      "Work Relationship Start Date": "2019-01-01",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1011",
      "Assignment Number": "ASGN011",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2019-01-01",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "6 months",
      "Probation End Date": "2019-07-01",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "Product Development",
      "Job": "UI/UX Designer",
      "Job Family": "Design",
      "Job Code": "DES01",
      "Reward Level": "Level 3",
      "Department": "User Experience",
      "Location Name": "Cape Town Studio",
      "Position Code": "POS1011",
      "Position": "Junior UI/UX Designer"
    },
    "Manager Information": {
      "Manager Flag": "No",
      "Manager Employee Number": "EMP108",
      "Manager Name": "Ben Carter"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Technical Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX778899001",
      "Bonus Agreement Score": "Good"
    },
    "Performance and Service": {
      "Years of service": "6",
      "Restraint flag": "No",
      "Notice period": "1 Month",
      "IPF score": "4.1",
      "Talent outcome score": "B"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 35000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 0 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 1700 },
          "Provident fund": { "Local": 1300 },
          "Risk benefits": { "Local": 650 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 280 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 200 },
          "Lifestyle benefits": { "Local": 500 },
          "Cellphone allowance": { "Local": 350 },
          "Per diem": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 250 },
          "Airtime": { "Local": 150 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 0 },
          "Overtime pay": { "Local": 0 },
          "Callout payment": { "Local": 0 },
          "Shift allowance": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 0 },
          "Performance share plan": { "Local": 1200 },
          "Performance bonus plan": { "Local": 1800 },
          "Sales commission scheme": { "Local": 0 },
          "Sales bonus": { "Local": 0 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 180 }
      }
    }
  },
  {
    "Employer Information": {
      "Legal Employer Name": "Optimum Solutions",
      "Employer company": "Optimum Group"
    },
    "Personal Identification": {
      "Person Number": "EMP012",
      "Surname": "Davies",
      "First Names": "Oliver",
      "Known As": "Ollie",
      "Title": "Mr",
      "Person Date of Birth": "1991-06-20",
      "Gender": "Male",
      "Marital Status": "Single",
      "Nationality": "South African",
      "Primary National Identifier Number": "9106201234078",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2028-08-01"
    },
    "Contact Information": {
      "Email Address": "oliver.davies@example.com",
      "Address Line 1": "22 Market Street",
      "City": "Pretoria",
      "Country": "South Africa",
      "Region 1": "Gauteng",
      "Region 2": "Tshwane"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2017-03-01",
      "Current Legal Employer Hire Date": "2017-03-01",
      "Work Relationship Start Date": "2017-03-01",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1012",
      "Assignment Number": "ASGN012",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2017-03-01",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "6 months",
      "Probation End Date": "2017-09-01",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "Legal & Compliance",
      "Job": "Legal Advisor",
      "Job Family": "Legal",
      "Job Code": "LEG01",
      "Reward Level": "Level 5",
      "Department": "Corporate Law",
      "Location Name": "Pretoria HQ",
      "Position Code": "POS1012",
      "Position": "Junior Legal Advisor"
    },
    "Manager Information": {
      "Manager Flag": "No",
      "Manager Employee Number": "EMP109",
      "Manager Name": "Helen Botha"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Professional Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX223344556",
      "Bonus Agreement Score": "Good"
    },
    "Performance and Service": {
      "Years of service": "8",
      "Restraint flag": "No",
      "Notice period": "2 Months",
      "IPF score": "4.2",
      "Talent outcome score": "B+"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 55000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 1800 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 2300 },
          "Provident fund": { "Local": 1900 },
          "Risk benefits": { "Local": 850 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 380 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 280 },
          "Lifestyle benefits": { "Local": 900 },
          "Cellphone allowance": { "Local": 580 },
          "Per diem": { "Local": 1100 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 300 },
          "Airtime": { "Local": 200 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 0 },
          "Overtime pay": { "Local": 0 },
          "Callout payment": { "Local": 0 },
          "Shift allowance": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 0 },
          "Performance share plan": { "Local": 2800 },
          "Performance bonus plan": { "Local": 3800 },
          "Sales commission scheme": { "Local": 0 },
          "Sales bonus": { "Local": 0 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 280 }
      }
    }
  },
  {
    "Employer Information": {
      "Legal Employer Name": "Pinnacle Ventures",
      "Employer company": "Pinnacle Group"
    },
    "Personal Identification": {
      "Person Number": "EMP013",
      "Surname": "Radebe",
      "First Names": "Sihle",
      "Known As": "Sihle",
      "Title": "Mr",
      "Person Date of Birth": "1994-07-11",
      "Gender": "Male",
      "Marital Status": "Single",
      "Nationality": "South African",
      "Primary National Identifier Number": "9407111234077",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2031-03-05"
    },
    "Contact Information": {
      "Email Address": "sihle.radebe@example.com",
      "Address Line 1": "44 Mountain View",
      "City": "Bloemfontein",
      "Country": "South Africa",
      "Region 1": "Free State",
      "Region 2": "Mangaung"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2021-09-01",
      "Current Legal Employer Hire Date": "2021-09-01",
      "Work Relationship Start Date": "2021-09-01",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1013",
      "Assignment Number": "ASGN013",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2021-09-01",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "3 months",
      "Probation End Date": "2021-12-01",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "Support Services",
      "Job": "Office Administrator",
      "Job Family": "Administration",
      "Job Code": "ADM01",
      "Reward Level": "Level 1",
      "Department": "Facilities",
      "Location Name": "Bloemfontein Office",
      "Position Code": "POS1013",
      "Position": "Junior Office Administrator"
    },
    "Manager Information": {
      "Manager Flag": "No",
      "Manager Employee Number": "EMP110",
      "Manager Name": "Brenda Adams"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Administrative Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX889900112",
      "Bonus Agreement Score": "Satisfactory"
    },
    "Performance and Service": {
      "Years of service": "3",
      "Restraint flag": "No",
      "Notice period": "1 Month",
      "IPF score": "3.5",
      "Talent outcome score": "C+"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 22000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 0 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 1200 },
          "Provident fund": { "Local": 900 },
          "Risk benefits": { "Local": 500 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 250 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 180 },
          "Lifestyle benefits": { "Local": 0 },
          "Cellphone allowance": { "Local": 250 },
          "Per diem": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 180 },
          "Airtime": { "Local": 100 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 0 },
          "Overtime pay": { "Local": 200 },
          "Callout payment": { "Local": 0 },
          "Shift allowance": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 0 },
          "Performance share plan": { "Local": 0 },
          "Performance bonus plan": { "Local": 500 },
          "Sales commission scheme": { "Local": 0 },
          "Sales bonus": { "Local": 0 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 100 }
      }
    }
  },
  {
    "Employer Information": {
      "Legal Employer Name": "Quantum Innovations",
      "Employer company": "Quantum Group"
    },
    "Personal Identification": {
      "Person Number": "EMP014",
      "Surname": "Govender",
      "First Names": "Sanjay",
      "Known As": "Sanjay",
      "Title": "Mr",
      "Person Date of Birth": "1982-05-25",
      "Gender": "Male",
      "Marital Status": "Married",
      "Nationality": "South African",
      "Primary National Identifier Number": "8205251234076",
      "Passport Country": "South Africa",
      "Passport Expiry Date": "2029-12-10"
    },
    "Contact Information": {
      "Email Address": "sanjay.govender@example.com",
      "Address Line 1": "30 Coral Lane",
      "City": "Durban",
      "Country": "South Africa",
      "Region 1": "KwaZulu-Natal",
      "Region 2": "eThekwini"
    },
    "Employment Dates": {
      "Enterprise Hire Date": "2009-08-01",
      "Current Legal Employer Hire Date": "2009-08-01",
      "Work Relationship Start Date": "2009-08-01",
      "Termination Date": ""
    },
    "Assignment Details": {
      "Assignment Identifier": "A1014",
      "Assignment Number": "ASGN014",
      "Assignment Category": "Permanent",
      "Assignment Start Date": "2009-08-01",
      "Assignment End Date": "",
      "Assignment Status": "Active",
      "Assignment Status Type": "Ongoing",
      "Full/Part Time": "Full Time",
      "Assignment Primary Flag": "Yes",
      "Probation Period": "6 months",
      "Probation End Date": "2010-02-01",
      "Synchronize From Position": "Yes"
    },
    "Job and Position": {
      "Business Unit Name": "Information Technology",
      "Job": "Network Administrator",
      "Job Family": "IT",
      "Job Code": "ITN02",
      "Reward Level": "Level 5",
      "Department": "Network Operations",
      "Location Name": "Durban Tech Hub",
      "Position Code": "POS1014",
      "Position": "Senior Network Administrator"
    },
    "Manager Information": {
      "Manager Flag": "No",
      "Manager Employee Number": "EMP111",
      "Manager Name": "Nolwazi Dlamini"
    },
    "Person Type": {
      "System Person Type": "Employee",
      "User Person Type": "Technical Staff"
    },
    "Compensation and Payroll": {
      "Payroll": "Monthly",
      "Tax Number": "TX990011223",
      "Bonus Agreement Score": "Excellent"
    },
    "Performance and Service": {
      "Years of service": "15",
      "Restraint flag": "No",
      "Notice period": "2 Months",
      "IPF score": "4.4",
      "Talent outcome score": "A-"
    },
    "Reward Details": {
      "Base / Gross Salary": {
        "Local Currency": "ZAR",
        "Basic pay": { "Local": 60000 }
      },
      "Structured Allowances and Benefits": {
        "Travel allowance": { "Local": 2800 },
        "xxxxx": { "Local": 0 }
      },
      "Other Allowances and Benefits": {
        "Obligatory / Mandatory": {
          "Medical aid": { "Local": 2500 },
          "Provident fund": { "Local": 2000 },
          "Risk benefits": { "Local": 900 },
          "xxxxx": { "Local": 0 }
        },
        "Non-obligatory / Elective": {
          "Funeral cover": { "Local": 450 },
          "xxxxxx": { "Local": 0 }
        },
        "Supplementary Allowances and Benefits": {
          "Canteen subsidy": { "Local": 300 },
          "Lifestyle benefits": { "Local": 1000 },
          "Cellphone allowance": { "Local": 600 },
          "Per diem": { "Local": 1200 },
          "xxxxx": { "Local": 0 }
        },
        "Other Supplementary Benefits": {
          "Data": { "Local": 350 },
          "Airtime": { "Local": 250 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Variable Pay": {
        "Supplementary Payments": {
          "Standby allowance": { "Local": 0 },
          "Overtime pay": { "Local": 0 },
          "Callout payment": { "Local": 0 },
          "Shift allowance": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        },
        "Incentives": {
          "Notional share options": { "Local": 0 },
          "Performance share plan": { "Local": 3500 },
          "Performance bonus plan": { "Local": 4500 },
          "Sales commission scheme": { "Local": 0 },
          "Sales bonus": { "Local": 0 },
          "Sign-on bonus": { "Local": 0 },
          "Retention bonus": { "Local": 0 },
          "ESOP": { "Local": 0 },
          "Group Fintech LTI scheme": { "Local": 0 },
          "Other incentive schemes": { "Local": 0 },
          "xxxxx": { "Local": 0 }
        }
      },
      "Reimbursements": {
        "Payment 1": { "Local": 350 }
      }
    }
  }
];

export default sampleEmployees;